// extracted by mini-css-extract-plugin
export var active = "_l3-2";
export var recordingDot = "_l3-1";
export var recordingIndicator = "_l3-0";